//@flow
import * as React from 'react';
import * as Immutable from 'immutable';
import { timeSlotsFactory } from 'common/entity/components/slot/TimeSlots';
import SingleSlotSelectorWithBreaks from 'common/entity/components/slot/SingleSlotSelectorWithBreaks';
import { DayShift } from 'common/models/internal/DayShift';
import ShiftLocationsInput from 'common/entity/components/dayShift/ShiftLocationsInput';
import { SlotType } from 'common/enums/SlotEnum';

const TimeSlotsWithBreaks = timeSlotsFactory({
    SingleSlotSelector: SingleSlotSelectorWithBreaks
});

type Props = {
    timeSlot: DayShift,
    selectedDays: Array<string>,
    theme: Object,
    onChange: Function,
    onAddBreakClick: Function,
    onCopyToAllClick: Function,
    onToggleDaySelection: Function,
    startLocationPlaceholder: string,
    endLocationPlaceholder: string
};

export class DayShiftSlot extends React.PureComponent<Props> {
    render() {
        const {
            timeSlot: dayShift,
            selectedDays,
            theme,
            t,
            onChange,
            onAddBreakClick,
            onCopyToAllClick,
            onToggleDaySelection,
            handleSingleSlotChange,
            startLocationPlaceholder,
            endLocationPlaceholder,
            ...others
        } = this.props;
        const { slot, dayOfWeek, breaks } = dayShift;
        return (
            <>
                <TimeSlotsWithBreaks
                    {...others}
                    breaks={breaks}
                    dayShift={dayShift}
                    slots={slot ? Immutable.List([slot]) : Immutable.List()}
                    dayOfWeek={dayOfWeek}
                    selectedDays={selectedDays}
                    theme={theme}
                    t={t}
                    onChange={onChange}
                    onCopyToAllClick={onCopyToAllClick}
                    onToggleDaySelection={onToggleDaySelection}
                    onAddBreakClick={onAddBreakClick}
                />
                {selectedDays.indexOf(dayOfWeek) >= 0 ? (
                    <ShiftLocationsInput
                        slotType={SlotType.CUSTOM}
                        onSlotChange={onChange}
                        startLocationPlaceholder={startLocationPlaceholder}
                        endLocationPlaceholder={endLocationPlaceholder}
                        t={t}
                        column
                        timeSlot={dayShift}
                        theme={theme}
                        handleSingleSlotChange={handleSingleSlotChange}
                    />
                ) : null}
            </>
        );
    }
}

export default DayShiftSlot;
